import { ITestimonial } from "../../types/CommonTypes";
import { getImageById } from "../../commons/constants/helpers";
import Fade from "react-reveal/Fade";
import VideoItem from "./VideoItem";
import SectionHeader from "../landing/SectionHeader";
import "../landing/landing.css";
import "./VideoSection.css";
import "../../styles/mobile-carousel.css";

interface IProps {
	item: ITestimonial;
}

const VideoSection = ({ item }: IProps) => {
	const { videos, images } = item;
	const backgroundImage = getImageById("banner", {
		images: images,
		texts: [],
	});

	return (
		<section
			id="gestion"
			className="video-section-container"
			style={{ backgroundImage: `url("${backgroundImage}")` }}
		>
			<div className="video-section-overlay" />
			<div className="video-section-content">
				<SectionHeader
					eyebrow="Gestión"
					title="Control político en video"
					light
				/>
				<Fade bottom duration={800}>
					<div className="video-grid mobile-carousel">
						{videos.map((video, index) => (
							<VideoItem
								key={index}
								url={video.url}
								title={video.title}
							/>
						))}
					</div>
				</Fade>
			</div>
		</section>
	);
};

export default VideoSection;
